<template>
    <FormRoot>
        <!-- Name -->
        <Field
            :form.sync="form"
            type="text"
            name="name"
            translate
            placeholder="Name"
            hint="(Optional) Name of the wallet"
        />

        <!-- Types -->
        <TypesSelector class="mt-3" :depth="1" @input="chooseTypes" :saveButton="false" />
        <div>
            <small class="d-block form-text text-muted">Select the types of wallet</small>
        </div>

        <!-- Actions -->
        <FormActions>
            <Submit class="float-right" :disabled="isFormDisabled" :loading="form.loading" @click="onSubmit"
                >Create group wallet</Submit
            >
        </FormActions>
    </FormRoot>
</template>

<script>
    import { Field, FormRoot, FormActions, Submit } from '@tech_hexeko/design-system'
    import Forms from '@/mixins/Forms'
    import TypesSelector from '@/components/Types/Selector'

    export default {
        components: {
            Field,
            FormRoot,
            FormActions,
            Submit,
            TypesSelector,
        },
        mixins: [Forms],
        props: {
            group: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                fields: {
                    name: null,
                    types: [],
                },
                messageSuccess: 'The group wallet has been created',
            }
        },
        computed: {
            isFormDisabled() {
                return !this.form.submittable || !(this.form.types && this.form.types.length > 0)
            },
        },
        methods: {
            submit() {
                return this.$api.groups.createWallet(this.group, this.$data.form.notNullData())
            },
            chooseTypes(types) {
                this.form.types = types
            },
        },
    }
</script>
